export default __webpack_public_path__ + "4782a807243de72e9b14272ef8e6353e.jpg";